const cardsData = {
  dataOne: {
    cardName: 'Ruby on rails "Road trip weels"',
    cardImage: '/images/roadTripWheels.png',
    cardMadeWith: [
      'Ruby on rails',
      'ORM',
      'PostgreSQL',
      'API'
    ],
    cardProjectLink: 'https://rails-car-booking-rentals-frontend.onrender.com/',
    cardSourceLink: 'https://github.com/luis-pomare/rails-car-booking-rentals-frontend'
  },
  dataTwo: {
    cardName: "Space Travelers' Hub",
    cardImage: '/images/spaceTravelersHub.png',
    cardMadeWith: [
      'React and Redux',
      'CSS',
      'Microverse API'
    ],
    cardProjectLink: 'https://62e3d790301b6c0b660edd94--transcendent-creponne-c9416a.netlify.app/',
    cardSourceLink: 'https://github.com/luis-pomare/Space-Travelers-Hub'
  },
  dataThree: {
    cardName: 'The Boys seasons',
    cardImage: '/images/theBoysSeasons.png',
    cardMadeWith: [
      'JavaScript',
      'Two APIs',
      'HTML',
      'CSS'
    ],
    cardProjectLink: 'https://luis-pomare.github.io/the-boys-seasons/dist/#',
    cardSourceLink: 'https://github.com/luis-pomare/the-boys-seasons'
  },
  dataFour: {
    cardName: 'GitHub Friends',
    cardImage: '/images/gitHubFriends.png',
    cardMadeWith: [
      'React and Redux',
      'CSS',
      'GitHub API'
    ],
    cardProjectLink: 'https://development--storied-crepe-b941b1.netlify.app/',
    cardSourceLink: 'https://github.com/luis-pomare/github-friends'
  },
  dataFive: {
    cardName: 'Bookstore',
    cardImage: '/images/Bookstore.png',
    cardMadeWith: [
      'React',
      'CSS',
      'React Router',
      'JavaScript'
    ],
    cardProjectLink: 'https://63031255330a6429601b98db--illustrious-sorbet-a4bf9d.netlify.app/',
    cardSourceLink: 'https://github.com/luis-pomare/bookstore'
  },
  dataSix: {
    cardName: 'Math Magicians',
    cardImage: '/images/mathMagicians.png',
    cardMadeWith: [
      'React',
      'CSS',
      'Calculator lib',
      'JavaScript'
    ],
    cardProjectLink: 'https://6303171c73d2452b1b1fa652--poetic-fairy-59c30f.netlify.app/',
    cardSourceLink: 'https://github.com/luis-pomare/math-magicians'
  },
}

export default cardsData;
